"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _types = require('web/screens/Signup/types');

var _utils = require('web/screens/Signup/utils');
var _signup = require('shared/enum/signup');
var _upgrade = require('shared/enum/upgrade');
var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _mfaErrors = require('shared/constants/mfaErrors');
var _gotoURL = require('web/services/gotoURL');
var _supportUrls = require('shared/data/supportUrls');
var _agreements = require('shared/data/agreements');






var _paymentContinuity = require('web/screens/onboardingShared/paymentContinuity');
var _readyToGoNotice = require('web/screens/onboardingShared/readyToGoNotice');











var _onboardingAnalytics = require('web/services/onboardingAnalytics');
var _signupDraft = require('../signupDraft');
var _useSubmit = require('./useSubmit');


var _stepErrors = require('../stepErrors');




















 const useIntermediateValues = ({
  token, gotoStep, currentStep, clampMaxStep, welcomeUser, wasInvitedByPhone, isPhoneRequired,
  onSubmitSetup, hasSignupInvites = null,
  onOrgMatchesChanged,
}) => {
  // A refresh-survivor draft (typed fields only — never password or MFA state)
  // seeds the wizard so a reload doesn't wipe the user's answers. Loaded once.
  const [draft] = _react.useState.call(void 0, () => _signupDraft.loadSignupDraft.call(void 0, token))
  const [personalInfo, setPersonalInfo] = _react.useState(_nullishCoalesce(_optionalChain([draft, 'optionalAccess', _ => _.personalInfo]), () => ( null)))
  const [password, setPassword] = _react.useState(null)
  const [signupMFAChallengeKey, setSignupMFAChallengeKey] = _react.useState()
  const [signupMFAMaskedPhone, setSignupMFAMaskedPhone] = _react.useState()
  const [verifiedSignupPhone, setVerifiedSignupPhone] = _react.useState()
  // The verified number is already on another active account: the phone step
  // offers sign-in before carrying on.
  const [phoneOnAnotherAccount, setPhoneOnAnotherAccount] = _react.useState.call(void 0, false)
  // Survey answers live here — not in OrgSurveySection — so they survive the
  // section unmounting (per-step remounts, and back-navigation from the
  // trial offer) — same reason `requestedOrgRels` lives in the hook.
  const [surveyAnswers, setSurveyAnswers] = _react.useState(
    _nullishCoalesce(_optionalChain([draft, 'optionalAccess', _2 => _2.surveyAnswers]), () => ( { referrer: null, productInterest: [] })),
  )
  // The completed survey, parked at the trial offer. Account creation is
  // deferred to an offer decision so the whole wizard stays freely revisitable
  // (back to the Organization step) until the user commits.
  const [pendingSurvey, setPendingSurvey] = _react.useState(null)
  const [legalAccepted, setLegalAccepted] = _react.useState.call(void 0, false)
  const [selectedTier, setSelectedTier] = _react.useState(
    _nullishCoalesce(_optionalChain([draft, 'optionalAccess', _3 => _3.selectedTier]), () => ( undefined)),
  )
  const [requestedOrgRels, setRequestedOrgRels] = _react.useState(_nullishCoalesce(_optionalChain([draft, 'optionalAccess', _4 => _4.requestedOrgRels]), () => ( [])))
  // Email signups learn about invitations from the server-derived matches at
  // the organization step; phone signups fall back to the welcome token's own
  // relationships.
  const isTokenInvited = _nullishCoalesce(hasSignupInvites, () => ( !!_optionalChain([welcomeUser, 'access', _5 => _5.Relationships, 'optionalAccess', _6 => _6.length])))
  // Every net_new signup sees the pre-auth offer and then bridges through login
  // to its selected action. This classification distinguishes SMS trial intent
  // from the free-team variant and keeps invited/join-request routing null.
  // Selected intents are a set (multi-select features step). A net-new signup
  // routes into a continuation once it has answered ≥1 intent. The org-selection
  // guard matters because the survey steps are freely revisitable: a signer can
  // answer intents, go back to the Organization step, and switch to joining an
  // existing org — stale answers must not route that join_request into a
  // continuation.
  const interests = surveyAnswers.productInterest
  const hasOnlyNewOrgs =
    requestedOrgRels.length > 0 && requestedOrgRels.every(r => !_utils.isExistingOrgRel.call(void 0, r))
  const netNewRouted = !isTokenInvited && hasOnlyNewOrgs && interests.length > 0
  // Seats are fixed at one during onboarding, so every non-SMS cohort receives
  // the free-team offer variant.
  const needsPaidPath = netNewRouted && interests.includes(_signup.ProductInterest.SMS)
  const continuation =
    needsPaidPath ? 'payment' : netNewRouted ? 'onboarding_steps' : null
  // Errors show inline on the step they are about (no warning bar).
  const [stepError, setStepError] = _react.useState(null)
  const reportStepError = _react.useCallback.call(void 0, 
    (step, message) => setStepError({
      step: _nullishCoalesce(_nullishCoalesce(step, () => ( currentStep)), () => ( _types.SetupSteps.PERSONAL_INFO)),
      message,
    }),
    [currentStep],
  )
  const clearStepError = _react.useCallback.call(void 0, () => setStepError(null), [])
  const handleOrgMatchesChanged = _react.useCallback.call(void 0, () => {
    setRequestedOrgRels([])
    _signupDraft.saveSignupDraft.call(void 0, token, { requestedOrgRels: [] })
    _optionalChain([onOrgMatchesChanged, 'optionalCall', _7 => _7()])
  }, [onOrgMatchesChanged, setRequestedOrgRels, token])
  const { onSubmit, onFinish, onMFAVerified, pendingMFA } =
    _useSubmit.useSubmit.call(void 0, 
      token, onSubmitSetup, gotoStep, isTokenInvited, continuation,
      () => setLegalAccepted(false), handleOrgMatchesChanged, reportStepError,
    )

  const captureStepCompleted = (step) => {
    _onboardingAnalytics.captureOnboardingEvent.call(void 0, 
      _onboardingAnalytics.ONBOARDING_EVENTS.STEP_COMPLETED,
      _onboardingAnalytics.getStepAnalyticsProperties.call(void 0, step),
    )
  }

  const emitOnce = (kind, attemptId, emit) => {
    const key = `onb_signup_${token}_${kind}_${attemptId}`
    try {
      if (sessionStorage.getItem(key)) return
      sessionStorage.setItem(key, '1')
    } catch (e) {
      // best-effort; analytics still emits when storage is unavailable
    }
    emit()
  }

  const onSavePersonalInfo = async (personalInfo) => {
    setStepError(null)
    if (isPhoneRequired && !personalInfo.phone) {
      reportStepError(_types.SetupSteps.PERSONAL_INFO, _stepErrors.PHONE_REQUIRED_ERROR)
      return
    }

    if (verifiedSignupPhone && verifiedSignupPhone !== personalInfo.phone) {
      setSignupMFAChallengeKey(undefined)
      setSignupMFAMaskedPhone(undefined)
      setVerifiedSignupPhone(undefined)
      setPhoneOnAnotherAccount(false)
    }

    setPersonalInfo(personalInfo)
    _signupDraft.saveSignupDraft.call(void 0, token, { personalInfo })
    if (!wasInvitedByPhone && personalInfo.phone && verifiedSignupPhone !== personalInfo.phone) {
      try {
        const r = await _client2.default.sendSignupMFAPhoneCode(token, personalInfo.phone)
        setSignupMFAChallengeKey(r.ChallengeKey)
        setSignupMFAMaskedPhone(r.MaskedPhone)
        captureStepCompleted(_types.SetupSteps.PERSONAL_INFO)
        gotoStep(_types.SetupSteps.PHONE_MFA)
      } catch (err) {
        // The sentence goes by the phone field; unknown errors are logged.
        reportStepError(_types.SetupSteps.PERSONAL_INFO, _mfaErrors.mfaErrorMessage.call(void 0, err))
      }
      return
    }

    captureStepCompleted(_types.SetupSteps.PERSONAL_INFO)
    gotoStep(_types.SetupSteps.PASSWORD)
    _amplitude2.default.logEvent("SIGN_UP_ADD_INFO")
  }

  const onVerifySignupMFA = async (code) => {
    if (!signupMFAChallengeKey || !_optionalChain([personalInfo, 'optionalAccess', _8 => _8.phone])) return
    const r = await _client2.default.verifySignupMFA(signupMFAChallengeKey, code)
    setSignupMFAMaskedPhone(r.MaskedPhone)
    setVerifiedSignupPhone(personalInfo.phone)
    if (r.PhoneOnAnotherAccount) {
      setPhoneOnAnotherAccount(true)
      return
    }
    captureStepCompleted(_types.SetupSteps.PHONE_MFA)
    gotoStep(_types.SetupSteps.PASSWORD)
  }

  const onContinueNewAccount = () => {
    setPhoneOnAnotherAccount(false)
    captureStepCompleted(_types.SetupSteps.PHONE_MFA)
    gotoStep(_types.SetupSteps.PASSWORD)
  }

  const onResendSignupMFA = async () => {
    if (!signupMFAChallengeKey) return
    const r = await _client2.default.resendSignupMFACode(signupMFAChallengeKey)
    setSignupMFAMaskedPhone(r.MaskedPhone)
  }

  const onSavePassword = (password) => {
    setStepError(null)
    setPassword(password)
    captureStepCompleted(_types.SetupSteps.PASSWORD)
    gotoStep(_types.SetupSteps.ORG_INFO)
    _amplitude2.default.logEvent("SIGN_UP_SET_PASSWORD")
  }

  const onSaveOrgRels = async (rels) => {
    setStepError(null)
    // A changed org selection invalidates everything derived downstream
    // (survey routing, the trial-offer variant), so forward jumps past the
    // next step are withdrawn until the user re-walks the flow.
    if (JSON.stringify(rels) !== JSON.stringify(requestedOrgRels)) {
      _optionalChain([clampMaxStep, 'optionalCall', _9 => _9(_types.SetupSteps.ORG_INFO)])
      setLegalAccepted(false)
    }
    setRequestedOrgRels(rels)
    _signupDraft.saveSignupDraft.call(void 0, token, { requestedOrgRels: rels })
    captureStepCompleted(_types.SetupSteps.ORG_INFO)
    if (rels.every(r => !_utils.isExistingOrgRel.call(void 0, r))) {
      return gotoStep(_types.SetupSteps.ORG_SURVEY_REFERRER)
    }

    return personalInfo && password
      ? onSubmit(personalInfo, password, rels, undefined, signupMFAChallengeKey)
      : null
  }

  const onSurveyAnswer = (answers) => {
    // Changing an already-given answer withdraws forward jumps beyond that
    // answer's step — the parked survey (pendingSurvey) only refreshes on the
    // product-interest submit, so the user must re-walk forward through it.
    if (answers.referrer !== undefined &&
        JSON.stringify(answers.referrer) !== JSON.stringify(surveyAnswers.referrer)) {
      _optionalChain([clampMaxStep, 'optionalCall', _10 => _10(_types.SetupSteps.ORG_SURVEY_REFERRER)])
    }
    if (answers.productInterest !== undefined &&
        JSON.stringify(answers.productInterest) !== JSON.stringify(surveyAnswers.productInterest)) {
      _optionalChain([clampMaxStep, 'optionalCall', _11 => _11(_types.SetupSteps.PRODUCT_INTEREST)])
    }
    setSurveyAnswers(prev => {
      const next = { ...prev, ...answers }
      _signupDraft.saveSignupDraft.call(void 0, token, { surveyAnswers: next })
      return next
    })
  }

  // Completing the survey parks it and advances to the agreement gate.
  // Account creation remains deferred until an offer decision.
  const onSaveOrgSurvey = (survey) => {
    setPendingSurvey(survey)
    gotoStep(_types.SetupSteps.LEGAL_AGREEMENTS)
  }

  const onAcceptLegalAgreements = async () => {
    if (!legalAccepted) return
    setStepError(null)
    captureStepCompleted(_types.SetupSteps.LEGAL_AGREEMENTS)
    // The trial offer is an SMS decision. A free (no-SMS) signup has nothing
    // to decide, so acceptance IS its commit — no interstitial offer screen.
    if (!_optionalChain([pendingSurvey, 'optionalAccess', _12 => _12.productInterest, 'access', _13 => _13.includes, 'call', _14 => _14(_signup.ProductInterest.SMS)])) {
      return commitTrialDecision('free_team', { estimates: {} })
    }
    gotoStep(_types.SetupSteps.TRIAL_OFFER)
  }

  const onTrialOfferViewed = (action) => {
    const attemptId = _paymentContinuity.getOrCreateSignupAttempt.call(void 0, token)
    emitOnce('viewed', attemptId, () =>
      _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_VIEWED, {
        ..._onboardingAnalytics.PAYMENT_STEP_META,
        attempt_id: attemptId,
        ...action.estimates,
      }))
  }

  const onTrialDemoViewed = (action) => {
    const attemptId = _paymentContinuity.getOrCreateSignupAttempt.call(void 0, token)
    emitOnce('demo_viewed', attemptId, () =>
      _onboardingAnalytics.captureOnboardingDemoCalloutViewed.call(void 0, {
        source: 'enterprise_callout',
        trigger: 'patients',
        attempt_id: attemptId,
        ...action.estimates,
      }))
  }

  const onTrialDemo = (action) => {
    const attemptId = _paymentContinuity.getOrCreateSignupAttempt.call(void 0, token)
    _onboardingAnalytics.captureOnboardingDemoClicked.call(void 0, {
      source: 'enterprise_callout',
      trigger: 'patients',
      attempt_id: attemptId,
      ...action.estimates,
    })
    window.open(_supportUrls.scheduleMeetingUrl, '_blank', 'noopener,noreferrer')
  }

  const onTrialSkipDialogViewed = (action) => {
    const attemptId = _paymentContinuity.getOrCreateSignupAttempt.call(void 0, token)
    emitOnce('skip_dialog', attemptId, () =>
      _onboardingAnalytics.captureOnboardingSkipDialogViewed.call(void 0, {
        attempt_id: attemptId,
        ...action.estimates,
      }))
  }

  const onTrialPricingError = () => {
    _onboardingAnalytics.captureOnboardingStepErrored.call(void 0, {
      error_kind: 'pricing_load',
      attempt_id: _paymentContinuity.getOrCreateSignupAttempt.call(void 0, token),
      ..._onboardingAnalytics.PAYMENT_STEP_META,
    })
  }

  // The trial decision is the net-new commit point. `onSubmit` remains
  // retry-safe for a used token, and the authenticated callback runs after
  // login (or after MFA verification) with the newly created org key.
  const commitTrialDecision = async (
    outcome,
    action,
  ) => {
    if (!legalAccepted) {
      reportStepError(_types.SetupSteps.LEGAL_AGREEMENTS, _stepErrors.AGREEMENTS_REQUIRED_ERROR)
      gotoStep(_types.SetupSteps.LEGAL_AGREEMENTS)
      return
    }
    if (!personalInfo || !password || !requestedOrgRels.length || !pendingSurvey) return
    const attemptId = _paymentContinuity.getOrCreateSignupAttempt.call(void 0, token)
    const submitted = await onSubmit(
      personalInfo, password, requestedOrgRels, pendingSurvey, signupMFAChallengeKey,
      { BaaVersion: _agreements.BAA_VERSION, TosVersion: _agreements.TOS_VERSION },
    )
    if (!submitted) throw new Error('signup submission failed')
    emitOnce('completed', attemptId, () => captureStepCompleted(_types.SetupSteps.TRIAL_OFFER))
    return onFinish(
      personalInfo,
      password,
      wasInvitedByPhone,
      pendingSurvey,
      async orgKey => {
        _paymentContinuity.rekeySignupAttempt.call(void 0, token, orgKey, attemptId)

        if (outcome !== 'trial') {
          emitOnce(outcome, attemptId, () =>
            _onboardingAnalytics.captureOnboardingPaymentAbandoned.call(void 0, {
              outcome,
              organization_id: orgKey,
              attempt_id: attemptId,
              ...action.estimates,
            }))
          _paymentContinuity.clearPaymentContinuity.call(void 0, orgKey)
          _actions2.default.gotoOnboardingDemo(orgKey)
          return
        }

        if (!action.selectedSmsItem) throw new Error('missing selected SMS tier')
        emitOnce('checkout_started', attemptId, () =>
          _onboardingAnalytics.captureOnboardingCheckoutStarted.call(void 0, {
            organization_id: orgKey,
            attempt_id: attemptId,
            ...action.estimates,
          }))
        try {
          const { URL } = await _actions2.default.getCheckoutURL({
            OrgKey: orgKey,
            Items: [
              { Type: _upgrade.SubscriptionItemType.TEAM, Units: 1 },
              { Type: _upgrade.SubscriptionItemType.SMS, Units: action.selectedSmsItem.Units },
            ],
            SuccessURL: _paymentContinuity.buildOnboardingReturnURL.call(void 0, 'success', orgKey, attemptId),
            CancelURL: _paymentContinuity.buildOnboardingReturnURL.call(void 0, 'cancelled', orgKey, attemptId),
            OnboardingTrial: true,
            AttemptID: attemptId,
          })
          _gotoURL.gotoURL.call(void 0, URL)
        } catch (err) {
          log.error(err instanceof Error ? err : String(err))
          _onboardingAnalytics.captureOnboardingStepErrored.call(void 0, {
            error_kind: 'checkout_start',
            organization_id: orgKey,
            attempt_id: attemptId,
            ..._onboardingAnalytics.PAYMENT_STEP_META,
          })
          _readyToGoNotice.setTrialStartFailedNotice.call(void 0, orgKey)
          _paymentContinuity.clearPaymentContinuity.call(void 0, orgKey)
          _actions2.default.gotoOnboardingDemo(orgKey)
        }
      },
    )
  }

  // Login-only finish. `SIGN_UP_COMPLETE` is no longer fired here: it now fires
  // once at signup submission (`useSubmit`) for every cohort, mirroring PostHog
  // `onboarding_completed`. Both the auto-login bridge (net_new SMS + free
  // paths) and the download-screen skip (invited/join-request) share this
  // handler.
  const handleFinish = async () => {
    if (!personalInfo || !password) return
    return onFinish(personalInfo, password, wasInvitedByPhone)
  }

  return {
    values: {
      personalInfo,
      password,
      requestedOrgRels,
      pendingMFA,
      signupMFAChallengeKey,
      signupMFAMaskedPhone,
      phoneOnAnotherAccount,
      surveyAnswers,
      pendingSurvey,
      selectedTier,
      needsPaidPath,
      continuation,
      legalAccepted,
      stepError,
    },
    handlers: {
      clearStepError,
      onSavePersonalInfo,
      onSavePassword,
      onSaveOrgRels,
      onSaveOrgSurvey,
      onSetLegalAccepted: setLegalAccepted,
      onAcceptLegalAgreements,
      onSurveyAnswer,
      onSelectedTierChange: (tier) => {
        setSelectedTier(tier)
        _signupDraft.saveSignupDraft.call(void 0, token, { selectedTier: _nullishCoalesce(tier, () => ( null)) })
      },
      onStartTrial: (action) => commitTrialDecision('trial', action),
      onSkipTrial: (action) => commitTrialDecision('skipped', action),
      onFreeContinue: (action) => commitTrialDecision('free_team', action),
      onTrialOfferViewed,
      onTrialDemoViewed,
      onTrialDemo,
      onTrialSkipDialogViewed,
      onTrialPricingError,
      onFinish: handleFinish,
      onDownloadFinish: handleFinish,
      onMFAVerified,
      onVerifySignupMFA,
      onResendSignupMFA,
      onContinueNewAccount,
    },
  }
}; exports.useIntermediateValues = useIntermediateValues
